document.addEventListener('DOMContentLoaded', function() {
  // Get the current day, hour, and minute
  const now = new Date();
  const today = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTime = currentHour + (currentMinute / 60); // Convert to decimal time
  
  // Get the hours elements
  const hendonHoursElement = document.getElementById('hendon-hours');
  const finchleyHoursElement = document.getElementById('finchley-hours');
  
  // Define opening hours for each location and day
  const openingHours = {
    hendon: {
      1: { open: 9, close: 17.5 }, // Monday
      2: { open: 9, close: 17.5 }, // Tuesday
      3: { open: 9, close: 17.5 }, // Wednesday
      4: { open: 9, close: 17.5 }, // Thursday
      5: { open: 9, close: 17.5 }, // Friday
      6: null, // Saturday - closed
      0: null  // Sunday - closed
    },
    finchley: {
      1: { open: 9, close: 17.5 }, // Monday
      2: { open: 9, close: 17.5 }, // Tuesday
      3: { open: 9, close: 17.5 }, // Wednesday
      4: { open: 9, close: 17.5, extraOpen: 16, extraClose: 20, extraNote: "(Private only)" }, // Thursday
      5: { open: 9, close: 17.5 }, // Friday
      6: { open: 9, close: 13, note: "(Private only)" }, // Saturday
      0: null  // Sunday - closed
    }
  };
  
  // Function to get next opening time
  function getNextOpeningTime(location) {
    const hours = openingHours[location];
    let nextDay = today;
    let daysToAdd = 0;
    
    // Check if currently open
    if (hours[today] && currentTime >= hours[today].open && currentTime < hours[today].close) {
      return null; // Currently open, no need for next opening time
    }
    
    // Special case for Thursday evening at Finchley
    if (location === 'finchley' && today === 4 && hours[today].extraOpen && 
        currentTime >= hours[today].extraOpen && currentTime < hours[today].extraClose) {
      return null; // Currently open in special hours
    }
    
    // If we're past closing time today, start checking from tomorrow
    if (!hours[today] || currentTime >= hours[today].close) {
      nextDay = (today + 1) % 7;
      daysToAdd = 1;
    }
    
    // Find the next day we're open
    let checkDay = nextDay;
    let daysChecked = 0;
    
    while (daysChecked < 7) {
      if (hours[checkDay]) {
        // Found next opening day
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const openingTime = hours[checkDay].open;
        const openHour = Math.floor(openingTime);
        const openMinute = Math.round((openingTime - openHour) * 60);
        
                let timeString = openHour > 12 ? 
          (openHour - 12) + ":" + (openMinute < 10 ? "0" + openMinute : openMinute) + "pm" : 
          openHour + ":" + (openMinute < 10 ? "0" + openMinute : openMinute) + "am";
        
        if (daysToAdd === 0) {
          return "Opens today at " + timeString;
        } else if (daysToAdd === 1) {
          return "Opens tomorrow at " + timeString;
        } else {
          return "Opens " + dayNames[checkDay] + " at " + timeString;
        }
      }
      
      // Move to next day
      checkDay = (checkDay + 1) % 7;
      daysToAdd++;
      daysChecked++;
    }
    
    return "Temporarily closed"; // If no opening times found in the next 7 days
  }
  
  // Function to check if location is currently open
  function isLocationOpen(location) {
    const hours = openingHours[location];
    
    if (!hours[today]) {
      return false; // Closed today
    }
    
    // Regular hours check
    if (currentTime >= hours[today].open && currentTime < hours[today].close) {
      return true;
    }
    
    // Special hours check for Finchley on Thursday
    if (location === 'finchley' && today === 4 && hours[today].extraOpen && 
        currentTime >= hours[today].extraOpen && currentTime < hours[today].extraClose) {
      return true;
    }
    
    return false;
  }
  
  // Function to format today's hours
  function formatTodayHours(location) {
    const hours = openingHours[location];
    
    if (!hours[today]) {
      return "Closed today";
    }
    
    const openHour = Math.floor(hours[today].open);
    const openMinute = Math.round((hours[today].open - openHour) * 60);
    const closeHour = Math.floor(hours[today].close);
    const closeMinute = Math.round((hours[today].close - closeHour) * 60);
    
    let openTimeStr = openHour > 12 ? 
      (openHour - 12) + ":" + (openMinute < 10 ? "0" + openMinute : openMinute) + "pm" : 
      openHour + ":" + (openMinute < 10 ? "0" + openMinute : openMinute) + "am";
      
    let closeTimeStr = closeHour > 12 ? 
      (closeHour - 12) + ":" + (closeMinute < 10 ? "0" + closeMinute : closeMinute) + "pm" : 
      closeHour + ":" + (closeMinute < 10 ? "0" + closeMinute : closeMinute) + "am";
    
    let hoursStr = openTimeStr + " - " + closeTimeStr;
    
    // Add note if exists
    if (hours[today].note) {
      hoursStr += " " + hours[today].note;
    }
    
    // Add extra hours for Thursday at Finchley
    if (location === 'finchley' && today === 4 && hours[today].extraOpen) {
      const extraOpenHour = Math.floor(hours[today].extraOpen);
      const extraOpenMinute = Math.round((hours[today].extraOpen - extraOpenHour) * 60);
      const extraCloseHour = Math.floor(hours[today].extraClose);
      const extraCloseMinute = Math.round((hours[today].extraClose - extraCloseHour) * 60);
      
      let extraOpenTimeStr = extraOpenHour > 12 ? 
        (extraOpenHour - 12) + ":" + (extraOpenMinute < 10 ? "0" + extraOpenMinute : extraOpenMinute) + "pm" : 
        extraOpenHour + ":" + (extraOpenMinute < 10 ? "0" + extraOpenMinute : extraOpenMinute) + "am";
        
      let extraCloseTimeStr = extraCloseHour > 12 ? 
        (extraCloseHour - 12) + ":" + (extraCloseMinute < 10 ? "0" + extraCloseMinute : extraCloseMinute) + "pm" : 
        extraCloseHour + ":" + (extraCloseMinute < 10 ? "0" + extraCloseMinute : extraCloseMinute) + "am";
      
      hoursStr += ", " + extraOpenTimeStr + " - " + extraCloseTimeStr;
      
      if (hours[today].extraNote) {
        hoursStr += " " + hours[today].extraNote;
      }
    }
    
    return hoursStr;
  }

    // Update Hendon hours
  if (hendonHoursElement) {
    const isHendonOpen = isLocationOpen('hendon');
    const hendonNextOpen = !isHendonOpen ? getNextOpeningTime('hendon') : null;
    const hendonHours = formatTodayHours('hendon');
    
    let hendonContent = '';
    
    if (isHendonOpen) {
      hendonContent = '<span class="status-open">Open now</span> ' + hendonHours;
    } else {
      hendonContent = '<span class="status-closed">Closed now</span> ';
      if (hendonNextOpen) {
        hendonContent += '<span class="next-open">' + hendonNextOpen + '</span>';
      } else {
        hendonContent += hendonHours;
      }
    }
    
    hendonHoursElement.innerHTML = hendonContent;
  }
  
  // Update Finchley hours
  if (finchleyHoursElement) {
    const isFinchleyOpen = isLocationOpen('finchley');
    const finchleyNextOpen = !isFinchleyOpen ? getNextOpeningTime('finchley') : null;
    const finchleyHours = formatTodayHours('finchley');
    
    let finchleyContent = '';
    
    if (isFinchleyOpen) {
      finchleyContent = '<span class="status-open">Open now</span> ' + finchleyHours;
    } else {
      finchleyContent = '<span class="status-closed">Closed now</span> ';
      if (finchleyNextOpen) {
        finchleyContent += '<span class="next-open">' + finchleyNextOpen + '</span>';
      } else {
        finchleyContent += finchleyHours;
      }
    }
    
    finchleyHoursElement.innerHTML = finchleyContent;
  }
  
  // Add pulse animation for first 10 seconds
  const phoneIcon = document.querySelector('.header__icon--phone-mobile');
  if (phoneIcon && !sessionStorage.getItem('hasVisited')) {
    phoneIcon.classList.add('pulse-animation');
    
    // Remove the pulse animation after 10 seconds
    setTimeout(function() {
      phoneIcon.classList.remove('pulse-animation');
    }, 10000); // 10 seconds
    
    // Set session storage flag
    sessionStorage.setItem('hasVisited', 'true');
  }
  
  // Handle phone icon click and close button
  const phonePopup = document.querySelector('.header__phone-popup');
  const closeButton = document.getElementById('phone-popup-close');
  
  if (phoneIcon && phonePopup) {
    // Phone icon click handler
    phoneIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle popup visibility
      if (window.getComputedStyle(phonePopup).display === 'none') {
        phonePopup.style.display = 'block';
        console.log('Showing popup');
      } else {
        phonePopup.style.display = 'none';
        console.log('Hiding popup');
      }
    });
  }
  
  if (closeButton && phonePopup) {
    // Close button click handler
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Hide popup
      phonePopup.style.display = 'none';
      console.log('Close button clicked - hiding popup');
    });
  }
  
  // Close popup when clicking outside
  document.addEventListener('click', function(e) {
    if (phonePopup && 
        phonePopup.style.display === 'block' && 
        !phonePopup.contains(e.target) && 
        !phoneIcon.contains(e.target)) {
      phonePopup.style.display = 'none';
      console.log('Clicked outside - hiding popup');
    }
  });
});




